import { Box, Card, CardContent, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { ZoneSetItem } from "../../api/zoneSet";
import { Loadable } from "../Loading/Loadable";
import LoadingBox from "../Loading/LoadingBox";
import LoadingWrapper from "../Loading/LoadingWrapper";

interface ZoneSetDisplayProps {
  zoneSet: Loadable<ZoneSetItem>;
}

interface DetailItemProps {
  title: string;
  value?: string;
  valueVariant?: Variant;
}

const DetailItem = (props: DetailItemProps) => (
  <Box paddingBottom="1rem">
    <Typography color="textSecondary" variant="caption">
      {props.title}
    </Typography>
    <Typography color="textPrimary" variant={props.valueVariant || "body2"}>
      {props.value}
    </Typography>
  </Box>
);

const ZoneSetDisplay = ({ zoneSet, ...rest }: ZoneSetDisplayProps) => {
  return (
    <Card {...rest}>
      <CardContent>
        <LoadingWrapper loadingInfo={zoneSet} loadingComponent={<LoadingBox />}>
          <Box
            sx={{
              alignItems: "left",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DetailItem
              title="Name"
              value={zoneSet.data.name}
              valueVariant="h3"
            />
            <DetailItem title="Description" value={zoneSet.data.description} />
            <DetailItem
              title="Effective Date"
              value={zoneSet.data.effective_date_utc}
            />
            <DetailItem
              title="Expiration Date"
              value={zoneSet.data.expiration_date_utc}
            />
            <DetailItem title="Created" value={zoneSet.data.created_date_utc} />
            <DetailItem
              title="Last Modified"
              value={zoneSet.data.last_modified_date_utc}
            />
          </Box>
        </LoadingWrapper>
      </CardContent>
    </Card>
  );
};

export default ZoneSetDisplay;
